export const US_STATES = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
  { code: "DC", name: "District of Columbia" },
];

export function kycMissingItems(user) {
  if (!user || user === false || user.role === "admin") return [];
  const identityRequired = user.identity_verification_required !== false;
  const status = String(user.identity_verification_status || "not_submitted").toLowerCase();
  const identityApproved = Boolean(user.identity_verified) || status === "approved";
  const items = [];
  if (!user.phone_verified) items.push("Phone verification");
  if (identityRequired) {
    if (!String(user.full_name || "").trim()) items.push("Full legal name");
    if (!String(user.date_of_birth || "").trim()) items.push("Date of birth");
    if (!String(user.state || "").trim()) items.push("State");
  }
  if (identityRequired && !identityApproved) {
    items.push(status === "pending" ? "ID/selfie approval pending" : "ID front, ID back, and selfie");
  }
  return items;
}

export function isKycComplete(user) {
  return kycMissingItems(user).length === 0;
}

export function formatKycRejectionReason(reason) {
  const raw = String(reason || "").trim();
  if (!raw) return "We could not approve your verification. Please retry with clear ID photos and a clear selfie.";
  return raw
    .replace(/Document number not detected/gi, "The document number could not be read")
    .replace(/Date of birth not detected/gi, "The date of birth could not be read")
    .replace(/First name and\/or last name not detected/gi, "The name on the ID could not be read")
    .replace(/No source image found for performing face match/gi, "The selfie could not be matched with the ID photo");
}

export function isKycExpiredReason(reason) {
  return /expired|timer expires|session expired/i.test(String(reason || ""));
}

export function kycRetryLabel(reason) {
  return isKycExpiredReason(reason) ? "Start KYC again" : "Resubmit KYC";
}

export function kycPrepItems() {
  return [
    "Keep your original ID card ready before you start.",
    "Use good light and keep the ID photo clear, not blurry.",
    "Allow camera permission for selfie/liveness check.",
    "Finish all Didit steps in one sitting so the session does not expire.",
  ];
}

export function formatKycPendingReason(reason) {
  const raw = String(reason || "").trim();
  if (!raw) return "Didit verification is still pending. Continue the verification session if it is not finished.";
  return raw
    .replace(/selfie face match/gi, "selfie face match")
    .replace(/selfie liveness check/gi, "selfie liveness check");
}
